var $ = require('jquery');

var PageVerticalSlide = function PageVerticalSlide() {
	var $actions = $('.client.-clickable');

	if($actions.length) {
		$actions.click(function(e) {
			e.preventDefault();

			$('html, body').clearQueue().animate({
				scrollTop: $('.row[data-client-id="' + $(this).attr('data-id') + '"]').offset().top
			});
		});
	}
}

module.exports = PageVerticalSlide;